import React from "react";
import {  FaInstagram, FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-zinc-900 text-white py-6 mt-4">
      <div className="mx-auto w-[90%] lg:w-3/4 max-w-6xl text-center">
        {/* Social Media Icons */}
        <div className="flex justify-center gap-6 text-2xl mb-4">
          <p>Asma Tariq Ansari</p>
          <a href="https://www.instagram.com/asmataariq/" className="hover:text-gray-400">
            <FaInstagram />
          </a>
          <a href="https://github.com/AsmaTariqA" className="hover:text-gray-400">
            <FaGithub />
          </a>
        </div>

        {/* Copyright */}
        <div className="text-md">
          <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
